import styled from "styled-components";

export const ProjectsAssetsStyled = styled.div`
  .linked-project-assets {
    margin-top: 40px;
    display: flex;
    justify-content: center;
  }
`;
